import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import * as sup from "superstruct";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { useMutation } from "@/modules/api/hooks/useMutation";
import {
  apiErrorValidate,
  basicErrorResponseValidator,
} from "@/modules/api/utils/apiErrorValidate";
import { signInMutation } from "@/modules/auth/api/mutations/signIn/signInMutation";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";
import { completeTutorialTestMutation } from "@/modules/tutorialTest/mutations/completeTutorialTestMutation";

const translationNamespace = "apiMessages/useCompleteTutorialTestMutation";

export const useCompleteTutorialTestMutation = () => {
  const jsonApi = useJsonApi();
  const history = useHistory();
  const { t } = useTranslation(translationNamespace);

  return useMutation([signInMutation.name], {
    mutationFn: completeTutorialTestMutation(jsonApi),
    onSuccess: () => {
      history.push(authenticatedRouting.buildUrl("testPassed"));
    },
    onError: (error) => {
      const [, apiError] = sup.validate(error, basicErrorResponseValidator);

      if (apiError?.response.status === 422) {
        const responseCodes = apiError.response.data.errors.map(
          (error) => error.code
        );
        if (responseCodes.includes("TEST_FAILED")) {
          history.push(authenticatedRouting.buildUrl("testFailed"));
          return;
        }
      }

      apiErrorValidate(error, {
        401: {
          UNAUTHORIZED: t(
            "You are not allowed to complete the test. Please sign in again"
          ),
        },
        403: {
          FORBIDDEN: t("You don't have an access to complete the test"),
        },
        404: {
          TUTORIAL_NOT_FOUND: t("The tutorial or step cannot cannot be found"),
        },
        422: {
          TUTORIAL_UPDATED: t(
            "The tutorial has been updated. Please refresh the app"
          ),
        },
      });
    },
    retry: false,
  });
};
